import React from "react";
import { Redirect, Route } from "react-router-dom";

// Stops protected pages from rendering until the user is logged in.
// Auth state lives in localStorage (same source as checkUserLogin in utils.js)
// so the gate stays consistent with existing per-page checks.
const PrivateRoute = ({ component: Component, render, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        const isAuthenticated = Boolean(localStorage.getItem("userID"));
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{ pathname: "/", state: { from: props.location } }}
            />
          );
        }
        if (Component) return <Component {...props} />;
        if (typeof render === "function") return render(props);
        return null;
      }}
    />
  );
};

export default PrivateRoute;
